import React, { useEffect, useRef } from 'react';
import { useSDK } from './components/sdk';
import { screenWidth } from '../../../common/globals';

export default function Scanner({
  style, onScan, paused = true, setPaused, centerInterestPoint = true
}) {
  const host = useRef(null);
  const { loading, sdk } = useSDK();

  useEffect(() => {
    async function start() {
      if (!loading && host.current) {
        sdk.connectToElement(host.current);
        await sdk.enableCamera(true);
        await sdk.onScan(async (barcodeCaptureMode, session) => {
          if (!barcodeCaptureMode) return;
          await sdk.enableScanning(false);
          setPaused(true);
          const barcode = session.newlyRecognizedBarcodes[0];
          onScan(barcode.data);
        });
      }
    }
    async function cleanup() {
      if (!loading) {
        sdk.detachFromElement();
        await sdk.enableScanning(false);
        await sdk.enableCamera(false);
      }
    }
    start();
    return () => {
      cleanup();
    };
  }, [loading]);

  function observeNodeHeight(node, callback) {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const newHeight = entry.contentRect.height;
        callback(newHeight);
      }
    });

    resizeObserver.observe(node);

    return () => {
      resizeObserver.unobserve(node);
      resizeObserver.disconnect();
    };
  }

  useEffect(() => {
    if (host.current && !loading) {
      const cleanup = observeNodeHeight(host.current, (newHeight) => {
        if (centerInterestPoint) {
          sdk.setPointOfInterest(newHeight);
        }
        if (!centerInterestPoint) {
          sdk.setPointOfInterest();
        }
      });

      return () => {
        cleanup();
      };
    }
  }, [host.current, loading]);

  useEffect(() => {
    if (loading) return;
    if (paused) {
      sdk.enableScanning(false);
    } else {
      sdk.enableScanning(true);
    }
  }, [loading, paused]);

  return <div ref={host} style={style} className={`${screenWidth <= 800 ? 'camera-wrap-small' : null}`} />;
}
